import styled from 'styled-components';

export const InvisibleButton = styled.button`
  padding: 4px;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: ${(props) => (props.active ? 'lightgray' : 'inherit')};
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;

  :focus {
    outline: none;
  }
`;
